module.exports = __webpack_public_path__ + "09_hair_brown.e43fb5cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/09_hair_brown.png
// module id = 2vTV
// module chunks = 0